// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.h9mNoc78rn65bzoiEajg{line-height:1.5rem;margin-bottom:20px;flex:1 0 auto;position:relative;overflow:hidden}.yN22zWDCBMYY3BZfmQIZ{text-align:center;color:var(--color-default);font-size:1rem;display:block;padding:5px;line-height:1.5rem}.yN22zWDCBMYY3BZfmQIZ img{max-width:164px;max-height:28px;margin:8px 5px 0}.rhGxug_7AZit14znB_Ja{position:absolute;top:0;left:0;right:0;bottom:0;overflow:hidden}.rhGxug_7AZit14znB_Ja>img{width:100%;height:100%}.MIC5Bjgiz3g9muy6_jmy{height:100%;position:relative;margin-right:-12px}.MIC5Bjgiz3g9muy6_jmy .r_u1iK6Ah0v8j6B0WPYX{display:flex;min-height:100%;flex-direction:column;justify-content:stretch}.uGsl5lxTyXHY9VtQ0UZS .Z67ASP305QfTrYStDzeY{display:flex}.uGsl5lxTyXHY9VtQ0UZS .Z67ASP305QfTrYStDzeY .xJcO0rQ4tQO9DlCkVfVl{padding:7px 0;flex:1 1 auto}.uGsl5lxTyXHY9VtQ0UZS .n1gN2ac4yb3yoQImmwa2{margin-left:14px;margin-bottom:12px;margin-top:2px}.L5wo0BkwNDLafkd9B3oK{flex:0 0 auto}.L5wo0BkwNDLafkd9B3oK img{max-width:109px;width:100%;border-radius:5px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"accordion": `h9mNoc78rn65bzoiEajg`,
	"collaboration": `yN22zWDCBMYY3BZfmQIZ`,
	"content": `rhGxug_7AZit14znB_Ja`,
	"leftPanel": `MIC5Bjgiz3g9muy6_jmy`,
	"leftPanelWrapper": `r_u1iK6Ah0v8j6B0WPYX`,
	"interviews": `uGsl5lxTyXHY9VtQ0UZS`,
	"entry": `Z67ASP305QfTrYStDzeY`,
	"text": `xJcO0rQ4tQO9DlCkVfVl`,
	"bioButtonWrapper": `n1gN2ac4yb3yoQImmwa2`,
	"videoThumb": `L5wo0BkwNDLafkd9B3oK`
};
export default ___CSS_LOADER_EXPORT___;
